import { cartLinesStyles } from "@insite/content-library/Widgets/Cart/CartLines";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesStyles.noCartLinesIcon = {
    src: ShoppingCart,
    size: 45,
    color: "#006bc0",
    css: css`
        margin-bottom: 20px;
    `,
}

cartLinesStyles.header = {
    condensedViewCheckboxGroup: {
        css: css`
            margin-left: auto;
        `,
    },
    condensedViewCheckbox: {
        typographyProps: {
            css: css`
                margin-left: 10px;
            `,
        },
    },
    overflowMenu: {
        cssOverrides: {
            wrapper: css`
                margin-left: 20px;
                span {
                    color:white !important;
                }
                ul {
                    background:#FFFFFF;
                }
            `,
        },
    },
    removeAllLink: {
        css: css`
            margin-left: 24px;
        `,
    },
    mainSection: {
        css: css`
            display: flex;
            align-items: center;
            padding-bottom: 5px;
        `,
    },
    warningIcon: {
        src: "AlertCircle",
        color: "danger.main",
        css: css`
            margin-right: 10px;
        `,
    },
    warningSection: {
        css: css`
            display: flex;
            align-items: center;
            border: 2px solid ${getColor("danger.main")};
            padding: 15px 10px;
        `,
    },
}

cartLinesStyles.backToTopButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        margin: 16px 0;
    `,
}